@import '~@customink/design-tokens/build/scss/variables.scss';
@import '../../global-styles/index.scss';
@import '../ci-apparel/ci-apparel.scss';

#solutionsLink {
  cursor: pointer;
}

.ciSolutions {
  gap: 1.75rem;

  &-column {
    padding-top: 1rem;
  }

  &-title {
    margin: 0;
    font-size: 1rem !important;
    font-weight: 700;
    padding: 0.5rem;
    color: $color-neutral-text-medium;
  }
}
